import _toConsumableArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
var PI = Math.PI,
  min = Math.min,
  max = Math.max;
var rnd2 = function rnd2(a) {
  return Math.round(a * 100) / 100;
};
var rnd3 = function rnd3(a) {
  return Math.round(a * 100) / 100;
};
export { default as clip_rgb } from './clip_rgb.js';
export { default as limit } from './limit.js';
export { default as type } from './type.js';
export { default as unpack } from './unpack.js';
export { default as last } from './last.js';
var TWOPI = PI * 2;
var PITHIRD = PI / 3;
var DEG2RAD = PI / 180;
var RAD2DEG = 180 / PI;

/**
 * Reverse the first three elements of an array
 *
 * @param {any[]} arr
 * @returns {any[]}
 */
function reverse3(arr) {
  return [].concat(_toConsumableArray(arr.slice(0, 3).reverse()), _toConsumableArray(arr.slice(3)));
}
export { PI, TWOPI, PITHIRD, DEG2RAD, RAD2DEG, min, max, rnd2, rnd3, reverse3 };